import { ErrorSerializer, serializeError } from "@gemma/serializers";

import { EmptyGuid } from "@gemma/utils";
import { Events } from "@timesheets/webapp-support";
import { GemmaError } from "@gemma/errors";
import { LogLevels } from "@gemma/logging";
import { ErrorResolvers, RecordAny } from "@gemma/typescript-types";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import axios from "axios";
import { v1 } from "uuid";

//@ts-ignore
if (!window.hasAxios) {
  //@ts-ignore
  window.hasAxios = true;
  //@ts-ignore
  window.axios = axios;
}

(<any>Error).stackTraceLimit = Infinity;

const errorSerializer = new ErrorSerializer();

const axiosInstance = axios.create({
  transformRequest: [
    data => {
      return JSON.stringify(data, function(_k, v) {
        if (v instanceof Error) {
          return serializeError(v);
        } else {
          return v === undefined ? null : v;
        }
      });
    },
  ],
});

async function reportType(type = LogLevels.Error, data: RecordAny | GemmaError, showErrorOverlay = WebApplicationConstants.show.errorOverlay) {
  let response, reportingId;
  let id;
  try {
    id = v1();

    if (!data) {
      data = new GemmaError("System Error: Client data missing", { sensitive: false, system: true, ui: false, resolver: ErrorResolvers.Client });
    }

    const serializedError = data instanceof Error ? await errorSerializer.serialize(data) : data;
    if (Object.prototype.hasOwnProperty.call(serializedError, "vm")) {
      delete (<GemmaError & { vm: unknown }>serializedError).vm;
    }

    response = await axiosInstance.post(process.env.VUE_APP_CLIENT_LOGGING_URL as string, { id, type: LogLevels[type], timestamp: new Date(), data: serializedError }, { withCredentials: true });
    reportingId = response.data.id;
  } catch (innerError) {
    reportingId = EmptyGuid;
    response = { data: { id: reportingId, message: "Could not report error", innerError } };
  }

  if (type === LogLevels.Warning) {
    const message = (data.message ? `${data.message} ` : "") + `(API reporting id: ${reportingId})`;
    await WebApplicationConstants.defaultLogger.warn(message);
  } else if (type === LogLevels.Error) {
    const error = data as GemmaError;
    let nextError: Error | GemmaError | undefined = error;
    let rootError: Error | GemmaError | undefined = undefined;
    while (nextError) {
      rootError = nextError;
      nextError = (nextError as GemmaError).innerError || (nextError as GemmaError).error;
    }
    // eslint-disable-next-line no-console
    console.error(rootError);
    const systemErrorEvent = new Events.SystemErrorEvent({ data: error, response, reportingId, showErrorOverlay }, id);
    await WebApplicationConstants.listenerEventBuses.system.emit(systemErrorEvent);
  }

  return response;
}

export const report = {
  async error(data: RecordAny, showErrorOverlay: boolean) {
    await reportType(LogLevels.Error, data, showErrorOverlay);
  },

  async warning(data: RecordAny, showErrorOverlay: boolean) {
    await reportType(LogLevels.Warning, data, showErrorOverlay);
  },
};
